import {
  TEMPLATES_FETCH_REQUEST,
  TEMPLATES_FETCH_SUCCESS,
  TEMPLATES_FETCH_FAILURE,
  TEMPLATES_CREATE_REQUEST,
  TEMPLATES_CREATE_SUCCESS,
  TEMPLATES_CREATE_FAILURE,
  TEMPLATES_UPDATE_REQUEST,
  TEMPLATES_UPDATE_SUCCESS,
  TEMPLATES_UPDATE_FAILURE,
  TEMPLATES_DELETE_REQUEST,
  TEMPLATES_DELETE_SUCCESS,
  TEMPLATES_DELETE_FAILURE,
  TEMPLATES_SET_FILTERS,
  TEMPLATES_CLEAR_ERROR,
} from "./templatesTypes";

const initialState = {
  templates: [],
  filteredTemplates: [],
  filters: {
    media: "all",
    lang_id: "all",
    search: "",
  },
  isLoading: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  error: null,
};

const applyFilters = (templates, filters) => {
  let filtered = templates;

  if (filters.media !== "all") {
    filtered = filtered.filter((t) => t.media === filters.media);
  }

  if (filters.lang_id !== "all") {
    filtered = filtered.filter((t) => t.lang_id === filters.lang_id);
  }

  if (filters.search) {
    const searchLower = filters.search.toLowerCase();
    filtered = filtered.filter(
      (t) =>
        t.event_type.toLowerCase().includes(searchLower) ||
        t.content.toLowerCase().includes(searchLower)
    );
  }

  return filtered;
};

const templatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case TEMPLATES_FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case TEMPLATES_FETCH_SUCCESS:
      return {
        ...state,
        templates: action.payload,
        filteredTemplates: applyFilters(action.payload, state.filters),
        isLoading: false,
        error: null,
      };

    case TEMPLATES_FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case TEMPLATES_CREATE_REQUEST:
      return {
        ...state,
        isCreating: true,
        error: null,
      };

    case TEMPLATES_CREATE_SUCCESS:
      const newTemplates = [...state.templates, action.payload];
      return {
        ...state,
        templates: newTemplates,
        filteredTemplates: applyFilters(newTemplates, state.filters),
        isCreating: false,
        error: null,
      };

    case TEMPLATES_CREATE_FAILURE:
      return {
        ...state,
        isCreating: false,
        error: action.payload,
      };

    case TEMPLATES_UPDATE_REQUEST:
      return {
        ...state,
        isUpdating: true,
        error: null,
      };

    case TEMPLATES_UPDATE_SUCCESS:
      const updatedTemplates = state.templates.map((template) =>
        template.id === action.payload.id ? action.payload : template
      );
      return {
        ...state,
        templates: updatedTemplates,
        filteredTemplates: applyFilters(updatedTemplates, state.filters),
        isUpdating: false,
        error: null,
      };

    case TEMPLATES_UPDATE_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.payload,
      };

    case TEMPLATES_DELETE_REQUEST:
      return {
        ...state,
        isDeleting: true,
        error: null,
      };

    case TEMPLATES_DELETE_SUCCESS:
      const remainingTemplates = state.templates.filter(
        (template) => template.id !== action.payload
      );
      return {
        ...state,
        templates: remainingTemplates,
        filteredTemplates: applyFilters(remainingTemplates, state.filters),
        isDeleting: false,
        error: null,
      };

    case TEMPLATES_DELETE_FAILURE:
      return {
        ...state,
        isDeleting: false,
        error: action.payload,
      };

    case TEMPLATES_SET_FILTERS:
      const newFilters = { ...state.filters, ...action.payload };
      return {
        ...state,
        filters: newFilters,
        filteredTemplates: applyFilters(state.templates, newFilters),
      };

    case TEMPLATES_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default templatesReducer;
